// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"8363":"7f819917","8428":"00f2183e"}[chunkId] || chunkId) + ".c4a62568608799da.js";
};